import { Button as DxButton } from 'devextreme-react/button'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Button } from 'reactstrap'

const COMPONENTS = {
  dx: DxButton,
  reactstrap: Button,
  html: 'button'
}

/**
 * MfButton component is a wrapper that allows for easier bulk changes
 *
 * @param {Object} props
 * @param {string} props.component - component to render
 *
 * @returns {JSX.Element} - Button component
 */
const MfButton = ({ component = 'reactstrap', ...props }, ref) => {
  const Component = COMPONENTS[component]

  return <Component ref={ref} {...props} />
}

MfButton.propTypes = {
  delay: PropTypes.number,
  children: PropTypes.node,
  component: PropTypes.oneOf(['dx', 'reactstrap', 'html'])
}

export default forwardRef(MfButton)
